<template>
    <form @submit.prevent="submit" class="tw:space-y-4">
        <BaseInputText
            :value="formName"
            @input="setFormName"
            label="Nombre"
            name="name"
            rules="required"
        />

        <div>
            <label class="tw:block tw:text-sm tw:font-medium tw:text-gray-700 tw:mb-1">
                Color
            </label>
            <input
                type="color"
                v-model="formColor"
                class="tw:block tw:w-full tw:h-10 tw:px-1 tw:py-1 tw:rounded tw:border tw:border-slate-300 tw:bg-white tw:cursor-pointer tw:focus:outline-none tw:focus:border-blue-400"
            />
        </div>

        <div class="tw:flex tw:justify-end">
            <Button type="submit" variant="primary">
                Guardar
            </Button>
        </div>
    </form>
</template>

<script setup>
    import { ref } from 'vue';
    import store from '@/store';
    import BaseInputText from '@/modules/admin/ui/BaseInputText.vue';
    import Button from '@/modules/admin/ui/Button.vue';

    const props = defineProps({
        etiqueta: {
            type: Object,
            required: true
        }
    });

    const emit = defineEmits(['terminado']);

    const formName = ref(props.etiqueta.name || '');
    const formColor = ref(props.etiqueta.color || '#000000');

    function setFormName(val) {
        formName.value = val;
    }

    function submit() {
        if (!formName.value) return;

        emit('terminado', {
            name: formName.value,
            color: formColor.value,
            teatro_id: store.getters.getTeatro?.id
        });
    }
</script>
